import style from '../UploadConfigModal.module.scss'
import { Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from '../UploadConfigModal.module.scss'
import { ChangeEvent, DragEvent } from 'react'
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile'

interface UploadFileDroppableProps {
    onDragOver: (event: DragEvent<HTMLDivElement>) => void
    onDragLeave: (event: DragEvent<HTMLDivElement>) => void
    onDrop: (event: DragEvent<HTMLDivElement>) => void
    onChange: (event: ChangeEvent<HTMLInputElement>) => void
    isDragging: boolean
    file: File | File[] | undefined
    isMultiple?: boolean
}

export const UploadFileDroppable = (props: UploadFileDroppableProps) => {
    const {
        onDragOver,
        onDragLeave,
        onDrop,
        onChange,
        isDragging,
        file,
        isMultiple,
    } = props


    return (
        <div
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            className={`${style.body} app-color-default ${
                isDragging && style.dragging
            }`}
        >
            <Form.Control
                className="w-75 app-color-default"
                type="file"
                size="sm"
                id="uploadConfigInput"
                onChange={onChange}
                multiple={isMultiple}
                style={{ display: 'none' }}
            />
            <Form.Label
                htmlFor="uploadConfigInput"
                className={`pointer px-2 d-flex flex-column align-items-center gap-2`}
            >
                <FontAwesomeIcon
                    className={styles.fileIcon}
                    icon={faFile}
                />
                <div className={styles.label}>
                    Drag or browse {isMultiple ? <b>several files</b> : 'a file'}
                </div>
            </Form.Label>
            <div className={styles.inputLabel}>
                {file && Array.isArray(file) ? null : (file?.name ?? '')}
            </div>
        </div>
    )
}
